import { render } from "./FpToBsComponent.vue?vue&type=template&id=1d4a5ad3&scoped=true&ts=true"
import script from "./FpToBsComponent.vue?vue&type=script&lang=ts"
export * from "./FpToBsComponent.vue?vue&type=script&lang=ts"

import "./FpToBsComponent.vue?vue&type=style&index=0&id=1d4a5ad3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4a5ad3"]])

export default __exports__